import {Phase2Api} from "./api";
import {ValidationRule} from "antd/lib/form";
import React from "react";

export function createChargeCodeValidator(api: Phase2Api){

    const defaultChargeCode = api.chargeCodes.getDefault();

    return (rule: ValidationRule, chargeCode: string, callback: (msg?: React.ReactNode) => void) => {
        if (defaultChargeCode){
            callback();
            return;
        }

        if (rule.required && !chargeCode){
            callback(rule.message);
            return;
        }

        callback();
    }
}